import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiZod } from '@/shared/api'
import { type Employee, EmployeeSchema } from '../model/schema'

export const employeeKeys = {
  all: ['employees'] as const,
  search: (q: string) => [...employeeKeys.all, 'search', q] as const,
}

// Справочник сотрудников хаба; пустой q отдаёт начало списка (для первого
// открытия пикера, чтобы он не был пустым до ввода).
export function employeesQueryOptions(q = '') {
  return queryOptions({
    queryKey: employeeKeys.search(q),
    queryFn: async (): Promise<Employee[]> => {
      const body = await apiGet('/employees', apiZod.zListEmployeesResponse, q ? { q } : undefined)
      return (body.data ?? []).map((dto) =>
        EmployeeSchema.parse({
          subject: dto.subject,
          username: dto.username,
          ...(dto.full_name ? { fullName: dto.full_name } : {}),
          departments: dto.departments ?? [],
        }),
      )
    },
    staleTime: 5 * 60 * 1000,
  })
}
